import { IProduct } from '../../store/products/types'

export type WrittenProductOption =
  | {
      type: 'all'
      value: string
      label: string
      productIds: number[]
    }
  | {
      type: 'product'
      value: string
      label: string
      productId: number
    }

export const buildWrittenProductOptions = (products: IProduct[] | null): WrittenProductOption[] => {
  if (!products) return []

  return products.reduce((prev, product) => {
    const children = product.children || []

    if (children.length > 0) {
      prev.push({
        type: 'all',
        value: `all:${product.absnum}`,
        label: `${product.name} (Усі)`,
        productIds: children.map((child) => child.absnum),
      })

      children.forEach((child) => {
        prev.push({
          type: 'product',
          value: String(child.absnum),
          label: child.name,
          productId: child.absnum,
        })
      })
    } else {
      prev.push({
        type: 'product',
        value: String(product.absnum),
        label: product.name,
        productId: product.absnum,
      })
    }

    return prev
  }, [] as WrittenProductOption[])
}

export const getWrittenProductSelectLabel = (value: string, options: WrittenProductOption[]) => {
  if (!value) return 'Усі'

  return options.find((option) => option.value === value)?.label || ''
}
